// components
import { Typography } from '@centria-ui/components/atoms/typography'
import { Input } from '../text'

// styles
import classes from './styles.module.scss'

// types
import type { InputsEnum, variantsEnum } from '@centria-ui/commons/enums'
import type { InputTextProps } from 'primereact/inputtext'
import type { FC, ReactNode } from 'react'

export interface InputGroupProps extends InputTextProps {
  label?: string
  prev?: string | ReactNode
  post?: string | ReactNode
  inputVariant?: keyof typeof InputsEnum
  inputColor?: typeof variantsEnum.light | typeof variantsEnum.white
}

export const InputGroup: FC<InputGroupProps> = ({
  label,
  prev,
  post,
  inputColor = 'light',
  inputVariant = 'block',
  ...props
}) => (
  <div className='w-100'>
    {label && (
      <Typography
        Tag='label'
        fontSize='small'
        className='mb-1'
        htmlFor={props.id}>
        {label}
      </Typography>
    )}
    <div className={`p-inputgroup ${classes.groupContainer}`}>
      {prev && <div className={classes.prev}>{prev}</div>}
      <Input
        {...props}
        inputColor={inputColor}
        className={classes.input}
        inputVariant={inputVariant}
      />
      {post && <div className={classes.post}>{post}</div>}
    </div>
  </div>
)
